"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeadQuoteRo = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../../common");
exports.LeadQuoteRo = typebox_1.Type.Object({
    first_name: typebox_1.Type.String(),
    csa_name: typebox_1.Type.String(),
    dumpster_size: typebox_1.Type.String(),
    service_location: typebox_1.Type.String(),
    material: typebox_1.Type.String(),
    quote_total: typebox_1.Type.String(),
    price_type: common_1.RollOffPricingType,
    ton_limit: typebox_1.Type.String(),
    rental_period: typebox_1.Type.String(),
    overage_fee: typebox_1.Type.String(),
    rental_extension_fee: typebox_1.Type.String(),
    special_material_string: typebox_1.Type.String(),
    quote_url: typebox_1.Type.String(),
    custom_message: typebox_1.Type.String(),
    max_rental_days: typebox_1.Type.String(),
    /**
     * as an empty string or in yyyy-mm-dd format
     */
    last_order_date: typebox_1.Type.String(),
});
//# sourceMappingURL=lead-quote-ro.js.map